(function($){
    $(document).ready(function(){
      const scx_data = $('#spl_cpx_data'),
      productName = scx_data.data('title'),
      productHandle = scx_data.data('handle'),
      handleCore = productHandle.slice(0, -3),
      search_url = `https://${window.location.hostname}/search?view=json&q="${productName}"`;
      $.ajax({
        url: search_url,
        method: "GET",
        success: function(data){
          const scxData = JSON.parse(data),
                scxResults = scxData.results
          let $counter = 0;
          $.each(scxResults, function(i, product){
            const prodHandle = product.handle,
            prodTitle = product.title,
            prodCoreHandle = prodHandle.slice(0, -3),
            prodSwatches = product.swatch,
            prodAvailable = product.available,
            prodColor = product.color,
            prodUrl = product.url;
            let $swatchContent = "";
            console.log(scxResults); 

            if(prodTitle == productName){
              let $selected = (prodTitle == productName) ? 'selected' : '',
                    $available = (prodAvailable) ? 'available' : 'disabled'

                $swatchContent = `<a href='${prodUrl}' class='swatch-btn swatch-option ${$selected} clr black ${$available}' data-swatch-index='${$counter}' option-type='2' option-id='15' option-label='${prodColor}' option-tooltip-thumb='${prodSwatches}' option-tooltip-value='${prodSwatches}' style='background: url(${prodSwatches}) no-repeat center; background-size: 100%;' ${$available}><span class='color-hover'>${prodColor}</span><input type='radio' id='swatch-0-${prodColor}' name='option-0' value='${prodColor}' style='display:none'></a>`
                $('#color_swatch_container').append($swatchContent)
                console.log($swatchContent); 
                // console.table(product)
                $counter++
            }
          })
        },
        error: function(data){
        }
      })
    })
})(jQuery)